module.exports = __webpack_public_path__ + "static/media/thumbnail_lush.b7f51c63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coverpageThemeThumbnails/thumbnail_lush.jpg
// module id = 1324
// module chunks = 17